import { render, staticRenderFns } from "./safe-sku-detail-table.vue?vue&type=template&id=3d095554&"
import script from "./safe-sku-detail-table.vue?vue&type=script&lang=js&"
export * from "./safe-sku-detail-table.vue?vue&type=script&lang=js&"
import style0 from "./safe-sku-detail-table.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports